const booleanSearch = {
  en: {
    booleanSearch: {
      query           : "Query",
      new_bool_query  : 'New Query',
      new_bool_group  : 'New Group',
      edit_bool_query : 'Edit Query',
      edit_bool_group : 'Edit Group',
      new_bool_tagSearch  : 'New Tag',
      edit_bool_tagSearch : 'Edit Tag',
      edit: 'Edit',
      last_activities : 'Last Activities',
      last_activity   : 'Last Activity',
      search_type: {
        multi: 'Multi Provider'
      },
      details: {
        title : 'Details',
        fields: {
          name            : 'Name',
          namePlaceholder : 'Search Name',
          description     : 'Description',
          searchType      : 'Search Type',
          multiSyntax   : 'Multi Syntax',
          searchTypePlaceholder: 'Select Type',
          tagCategory     : 'Tag Category',
          tagCategoryPlaceholder: 'Select Category',
          isPrivateTag    : 'Private Tag',
          apply_cbs_outlet_timeframes: 'Apply CBS Outlet Timeframes',
          apply_cbs_outlet_timeframes_description: 'When enabled, only clips scheduled within the included timeframes configured in the outlet\'s CBS Auto settings will match this search. Clips outside these timeframes will be excluded even if they match other search criteria.'
        },
      },
      filters: {
        title : 'Filters',
        fields: {
          locations             : 'Locations',
          includeLocations      : 'Include Locations',
          excludeLocations      : 'Exclude Locations',
          includeStates         : 'Include States',
          excludeStates         : 'Exclude States',
          includeLanguages      : 'Include Languages',
          excludeLanguages      : 'Exclude Languages',
          includeOutlets        : 'Include Outlets',
          excludeOutlets        : 'Exclude Outlets',
          includeOutletGroups   : 'Include Outlet Groups',
          excludeOutletGroups   : 'Exclude Outlet Groups',
          includeMediaSubtypes  : 'Include Media Subtypes',
          excludeMediaSubtypes  : 'Exclude Media Subtypes',
          includeCategories     : 'Include Categories',
          excludeCategories     : 'Exclude Categories',
          includeTags           : 'Include Tags',
          excludeTags           : 'Exclude Tags',
          outletCategories      : 'Categories',
          twitterFilters        : 'X (formerly Twitter) Filters',
          twitterSearches       : 'X (formerly Twitter) Searches',
          twitterMinFollowers   : 'Minimum Number Of Followers',
          keywords              : 'Keywords for manual upload',
          keywordsAdd           : 'Add keyword...',
          biolocations          : 'X (Formerly Twitter) Bio Location',
          deepSearchLocation    : 'Deep Search Location',
          minFollowerBiolocation: 'Minimum Number Of Followers For Deep Search',
          locationsBiolocation  : 'Locations For Deep Search',
          includeUsers          : 'Include Users',
          excludeUsers          : 'Exclude Users',
          mustIncludeTerms      : 'Search Terms - Match All',
          shouldIncludeTerms    : 'Search Terms - Match One',
          mustExcludeTerms      : 'Search Terms - Exclude all',
          search_terms_description : 'At least one "match all" term is required',
          socialInfluencer      : 'Social Influencers Providers',
          includeInfluencers    : 'Include Influencers Group'
        },
        create: 'Press enter to add location',
        create_term: 'Press enter to add term',
        create_user: 'Press enter to add user'
      },
      select: {
        all: 'Select All',
        discard_selection: 'Discard Selection',
        clone: 'Clone',
        no_project_selected: 'Please select a project',
        clone_selected: 'Clone Selected',
        confirm_clone: 'Clone {0} {1} into Project?',
        delete: 'Delete',
        confirm_delete: 'Are you sure you want to delete {0} {1}?',
        cloned_successfully: 'Cloned successfully',
        cloned_failed: 'Clone failed',
        deleted_successfully: 'Deleted successfully',
        delete_failed: 'Delete failed',
        make_public: 'Make Public',
        make_private: 'Make Private',
      },
      sort: {
        sort_by_date: 'Sort by date',
        sort_by_name: 'Sort by name'
      },
      queries: {
        title: "Queries",
        linked_title: 'Linked Queries',
        link_search_info: 'Displays searches that are linked to this tag. Each search maintains its own filters and Boolean logic independently. The tag serves as a mirror/copy that can be created from any of these searches.',
        fields: {
          query: {
            title: 'Query',
            description: ''
          },
          user_query: {
            title: 'Lucene Query for Pipeline (Case Sensitive)',
            description: 'Case sensitive query will not ignore case. For example: ((Dubai AND CARMA) OR UAE), Only exact case of words will be matched'
          },
          standard_query: {
            title: 'Lucene Query Pattern (Do not break words by space)',
            multi_provider_title: 'All in one search',
            after_filter_title: 'Additional Optional Lucene Filter Query Pattern (Do not break words by space)',
            after_filter_description: 'Additional Optional Lucene Filter Query Pattern (Do not break words by space), even if filtered it will be counted and reduce the remaining limit of X (formerly Twitter) articles for the project',
            after_filter_tooltip: 'Generate after filter',
            description: 'It will not break words into spaces and will try to match by a pattern. For example "fire" will match "fireman" and "re" will match "fireman". Most common use is for Chinese languages'
          },
          regex_query: {
            title: 'Lucene Query for Pipeline (Case Insensitive)',
            description: 'Case insensitive query will ignore case. For example: ((Dubai AND CARMA) OR UAE), Words like dubai, carma, uae in any case will be matched'
          },
          media_track_query: {
            title: 'Media Track Query (Read Only)',
            description: 'This is the Media Track Query version of the query that will be stored on Media Track server. The end of it will be the list of outlets that will be searched on MT side.'
          },
          manual_upload: {
            title: 'Keywords for manual upload',
            description: ''
          }
        }
      },
      tags: {
        title: 'Linked Tags',
        create: 'Create Tag',
        fields: {
          tags: 'Tags',
          add_tag: 'Press enter to create new tag',
          no_tag_options: 'Type to search or add a tag'
        },
        link_tag_info: 'Creates/Links tags that exactly mirror this search, including all filters and Boolean logic. Linked tags stay synced with the search and update automatically. If the search is deleted, the tags remain active using the last known configuration for historical tracking.',
        link_tag_to_search: 'Link tags to search',
        manage_tags: 'Manage Tags',
        no_results: "No tags were linked yet",
        tags_updated_successfully: "Linked tags where updated sucessfully"
      },
      podcast_instructions: 'For TVEyes Podcast queries please: ',
      podcast_text: `Don't use groups for now`,
      ignored_chars: 'Please note the following characters are ignored:',
      ignored_chars_list: ' , ; .  : (  ) [ ] _ \' " （ ） 、 ， ’ ? < > - « »',
      confirm_delete: 'Do you really want to delete Query?',
      clone_and_save: 'Clone & Save',
      clone_into_project_placeholder: 'Clone into a Project',
      clone_into_client_placeholder: 'Clone into a Client',
      clone_into_project_message: 'Clone into Project',
      clone_into_client_message: 'Clone into Client',
      search_create_success_message: 'Search query successfully created',
      search_update_success_message: 'Search query successfully updated',
      search_delete_success_message: 'Search query successfully deleted',
      group_create_success_message: 'Group successfully created',
      group_update_success_message: 'Group successfully updated',
      group_delete_success_message: 'Group successfully deleted',
      tagSearch_create_success_message: 'Tag successfully created',
      tagSearch_update_success_message: 'Tag successfully updated',
      tagSearch_delete_success_message: 'Tag successfully deleted',
      tagsVisibility: 'Filter by visibility',
      changed_visibility: 'Visibility successfully updated',
      err_changing_visibility: 'Error changing visibility',
      delete_success_message: 'Deleted successfully',
      cloned_placeholder: 'Name your cloned Search',
      cloned_placeholder_group: 'Name your cloned Group',
      cloned_placeholder_tagSearch: 'Name your cloned Tag',
      cloned_success_message: 'Search query successfully cloned',
      cloned_error_message:   'Search query could not be cloned',
      export: 'Export',
      export_all: 'Export All',
      export_success_message: 'Search query successfully exported | Search queries successfully exported',
      export_error_message:   'Search query could not be exported | Search queries could not be exported',
      tagSearch_export_success_message: 'Tag successfully exported | Tags successfully exported',
      tagSearch_export_error_message:   'Tag could not be exported | Tags could not be exported',
      upload: 'Upload (only for Twitter)',
      upload_v3: 'Upload (X v3)',
      upload_tag: 'Upload Tags',
      upload_text: 'Use this form to upload searches for creation, updates, or deletion. Ensure the Excel file has the correct headers and format. <a href="/excel/searches-import-sample.xlsx">Download a sample file</a> for reference.',
      upload_text_v3: 'Use this form to upload X (Twitter) v3 searches for creation, updates, or deletion. v3 searches use a boolean query, not Match All / Match One / Exclude terms. <a href="/excel/twitter-v3-searches-import-sample.xlsx">Download a sample file</a> for reference. Required columns: Action, Name, Type (twitter_search_v3), and case_insensitive_query. Optional: description, non_space_query (after filter), include_languages, exclude_languages, include_users, exclude_users, twitter_filters, twitter_min_followers, biolocations (array of full-text bio locations), include_countries (deep-search countries), and min_follower_biolocation (minimum followers for deep search).',
      upload_text_tag: 'Use this form to upload tags for creation, updates, or deletion. Ensure your Excel file includes the required headers and follows the correct format. <a href="/excel/tags-import-sample.xlsx">Download a sample file</a> for reference. Most columns are optional - for example, if you only want to update the name, you can include just the ID, name, and action columns. Any columns not provided will remain unchanged for existing tags.',
      upload_stale_message: 'The processing is taking longer than expected. You may {0} and reupload the file to try again.',
      upload_stale_action: 'cancel the upload',
      upload_success_message: 'File processed successfully',
      upload_complete_with_errors: 'File processed with errors',
      upload_complete_report_message: 'File processed with errors. {0}',
      upload_complete_report_action: 'Download the error report here.',
      upload_error_message: 'File could not be processed',
      upload_toggle_history: 'Toggle recent uploads',
      upload_last_updated_at: 'Last updated at',
      upload_running: 'Your upload is running in the background. You can safely close this window.',
      upload_status: {
        completed: 'Completed',
        possibly_stale: 'Possibly Stale',
        error: 'Error',
        in_progress: 'In Progress'
      },
      upload_header: {
        status: 'Status',
        updated_at: 'Updated At',
        report: 'Error Report'
      },
      no_data: 'No data found',
      loading: 'Loading...',
      load_more: 'Load More',
      all_data_loaded: 'All {0} are loaded',
      query_validation: {
        no_error: 'No Errors',
        generic_error: 'Invalid Query',
        missing_opening_brackets: 'Opening bracket(s) missing',
        missing_closing_brackets: 'Closing bracket(s) missing',
        missing_quotes: 'Double quote(s) missing',
        invalid_start_char: 'Query cannot start with * or ? characters',
        invalid_start_end_boolean_operators: 'Query cannot start or end with Boolean Operators (AND / OR / AND NOT)',
        invalid_consecutive_operators: 'Boolean Operators (AND / OR / AND NOT) cannot be consecutive',
        required: 'A query is required to create a search or group'
      },
      delete_attention: {
        title: 'Attention Required',
        message: 'The current Group is in use by one or more Search(es) / Group(s). Please update each listed below and try again:',
        try_again: 'Try Again'
      },
      filter_by_type: 'Filter by Search Type',
      search_terms_count_limit: 'Total search terms cannot exceed {count}'
    }
  }
}

module.exports.booleanSearch = booleanSearch;